<style lang="scss" scoped>
.scope {
  background: whitesmoke;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  height: 100%;
}
.scope-header {
  background-color: var(--v-primary-base);
  color: whitesmoke;
  padding: 8px 16px;
  border-radius: 4px;
}
:deep(.v-breadcrumbs__divider) {
  color: whitesmoke !important;
}
@media screen and (min-width: 601px) {
  .example {
    font-size: 80px;
  }
}

@media screen and (max-width: 600px) {
  .example {
    font-size: 30px;
  }
}
</style>
<template>
  <div
    ref="scopeRoot"
    class="font-weight-bold px-3 scope pa-2"
    :class="{ 'disable-pointer-events': viewOnly }"
    id="scope-btn-open"
  >
    <v-icon
      :class="scopeIconStyle"
      v-if="!viewOnly"
    >
      mdi-file-tree-outline
    </v-icon>

    <div @click="scopeClick">
      <v-breadcrumbs class="scope-header clickable" v-if="items.length" :items="items">
        <template v-slot:item="{ item }:{item:any}">
          <v-breadcrumbs-item>
            {{$utils.servertranslate(item.name) }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <div v-else-if="!viewOnly" class="d-flex clickable">
        <h4 class="scope-header">{{ $t("Scope") }}</h4>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import emitter from '@/shared/utils/emitter';
import { COURSES_ROUTE_NAME } from '@/enums';
import { ScopeComponentInterface } from '../types/general.type';

export default defineComponent({
  name: 'ScopeTree',
  props: {
    lastLevel: {
      type: Boolean,
      default: false,
    },
    departmentLevel: {
      type: Boolean,
      default: false,
    },
    facultyLevel: {
      type: Boolean,
      default: false,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items(): any {
      return this.$store.state.scope.scopeList;
    },
    scopeIconStyle(): any {
      return this.$store.state.lang.lang === 'en' ? 'mr-4' : 'ml-4';
    },
  },
  watch: {
    '$store.state.scope.selectedScopeId': {
      handler: 'onScopChange',
      deep: true,
    },
  },
  mounted() {
    if (this.reset) {
      this.$store.commit('resetScope');
    }
    this.setTreeLevel(this.lastLevel, this.departmentLevel, this.facultyLevel);
  },
  methods: {
    setFocus() {
      emitter.emit('scopFocus');
    },
    setTreeLevel(isLastLevel, isDepartmentLevel, isFacultyLevel) {
      this.$store.commit('setTreeLastLevel', isLastLevel);
      this.$store.commit('setTreeDepartmentLevel', isDepartmentLevel);
      this.$store.commit('setTreeFacultyLevel', isFacultyLevel);
    },
    scopeClick() {
      if (this.viewOnly) {
        return;
      }
      if (this.$route.name !== COURSES_ROUTE_NAME.ADD) {
        this.$store.commit('setTreeStartLevel', 0);
      }
      this.$store.commit('openDrawer');
      this.$store.commit('openScope');
    },
    onScopChange(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('onScopeChange', this.$store.state.scope.selectedScopeId);
      }
    },
  },
});
</script>
